import { SubscriptionProviderContext } from '@tv2/lib-offspring/api/user/Subscription';
import { useQuery } from '@tv2/lib-graphql/client';
import { useIsLoggedIn } from '@tv2/lib-offspring/api/user/UserProvider';
import { useTick } from '@tv2/ui-time/components/context/TimeContext';
import { SubscriptionDocument } from './__generated__/Subscription';

export function SubscriptionProvider({ children }: { children: React.ReactNode }) {
  const subcription = usePrimarySubscription();
  return (
    <SubscriptionProviderContext subscription={subcription}>{children}</SubscriptionProviderContext>
  );
}

export const usePrimarySubscription = () => {
  const now = new Date(useTick()).toISOString().substring(0, 10);
  const isLoggedIn = useIsLoggedIn();

  const { data, fetching } = useQuery({
    pause: !isLoggedIn,
    query: SubscriptionDocument,
    variables: { now },
    requestPolicy: 'cache-first',
  });

  return {
    loading: fetching,
    subscription: data?.primaryUserSubscription ?? null,
  };
};
